import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchHistorySuccess,
  fetchHistoryFailure,
  updateHistorySuccess,
  updateHistoryFailure,
} from "../slices/VehicleHistorySlice";
import { request } from "src/utils/api";
import { StatusCodes } from "http-status-codes";
import { FETCH_HISTORY, UPDATE_HISTORY } from "../actions/VehicleHistoryAction";
import message from "antd/es/message";
import notification from "antd/es/notification";

export function* fetchhistorySaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK) yield put(fetchHistorySuccess(result));
    else {
      yield put(fetchHistoryFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchHistoryFailure(error.message));
  }
}

export function* updateHistorySaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    // if (result.status >= 200 && result.status < 300)
    if (result.status == StatusCodes.OK) {
      yield put(updateHistorySuccess(result.data));
      notification.success({
        message: "Update success",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    } else {
      yield put(updateHistoryFailure(result.message));
      notification.error({
        message: "Update Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error) {
    yield put(updateHistoryFailure(error));
  }
}

export default function* historySaga() {
  yield all([
    takeLatest(FETCH_HISTORY, fetchhistorySaga),
    takeLatest(UPDATE_HISTORY, updateHistorySaga),
  ]);
}
